
import React, { PureComponent } from 'react';
import Constants from '../Constants.js';
import Styles from './BoardStyles.js'



class OuterTile extends PureComponent {
  render() {
    return (
      <div style={{
        ...Styles.Tile,
        ...Styles.OuterTile,
        backgroundColor: (this.props.transitioning ? this.props.colors.secondary : Constants.innerColor),
        left: (this.props.col * Constants.tileSize) + 'px',
        top: (this.props.row * Constants.tileSize) + 'px',
      }}>
        <div
          style={{
            ...Styles.OuterTileInner,
            backgroundColor: (this.props.transitioning ? this.props.colors.primary : Constants.outerColor),
            borderTopLeftRadius: (this.props.topLeftRounded ? Constants.outerBorderRadius : 0 ) + 'px',
            borderTopRightRadius: (this.props.topRightRounded ? Constants.outerBorderRadius : 0 ) + 'px',
            borderBottomRightRadius: (this.props.bottomRightRounded ? Constants.outerBorderRadius : 0 ) + 'px',
            borderBottomLeftRadius: (this.props.bottomLeftRounded ? Constants.outerBorderRadius : 0 ) + 'px',
          }}
        />
      </div>
    );
  }
}

export default OuterTile;
